<template>
  <span v-if="hasAntiTheftDeviceInvoice">
    <DocumentAnalysisBadge
      :verdict="analysisVerdict"
      :is-analyzed="Boolean(antiTheftDeviceInvoiceAnalyzedAt)"
      :has-error="analysisHasError"
      :tooltip="analysisBadgeLabel"
      :clickable="canOpenAnalysisModal"
      @click="analysisModalOpen = true"
    />
    <AntiTheftDeviceInvoiceAnalysisModal
      :open="analysisModalOpen"
      :analysis="antiTheftDeviceInvoiceAnalysis"
      :analyzed-at="antiTheftDeviceInvoiceAnalyzedAt"
      :analysable-id="declaration.id"
      analysable-type="Claims::Declaration"
      :claim-active="claimActive"
      @close="analysisModalOpen = false"
      @retry-success="$emit('retry-success')"
    />
  </span>
</template>

<script>
import { useI18n } from "vue-i18n";
import DocumentAnalysisBadge from "@/components/claim/details/DocumentAnalysisBadge.vue";
import AntiTheftDeviceInvoiceAnalysisModal from "@/components/claim/details/AntiTheftDeviceInvoiceAnalysisModal.vue";
import { verdictLabel } from "@/components/claim/details/antiTheftDeviceInvoiceAnalysisFormatter";

export default {
  components: {
    DocumentAnalysisBadge,
    AntiTheftDeviceInvoiceAnalysisModal,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  emits: ["retry-success"],
  props: {
    declaration: {
      type: Object,
      default: null,
    },
    claimActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      analysisModalOpen: false,
    };
  },

  computed: {
    hasAntiTheftDeviceInvoice() {
      return (this.declaration?.antiTheftDeviceInvoice?.length || 0) > 0;
    },
    antiTheftDeviceInvoiceAnalysis() {
      return this.declaration?.antiTheftDeviceInvoiceAnalysis || null;
    },
    antiTheftDeviceInvoiceAnalyzedAt() {
      return this.declaration?.antiTheftDeviceInvoiceAnalyzedAt || null;
    },
    analysisVerdict() {
      return (
        this.declaration?.antiTheftDeviceInvoiceAnalysisVerdict ||
        this.antiTheftDeviceInvoiceAnalysis?.overallVerdict ||
        null
      );
    },
    analysisHasError() {
      return Boolean(this.antiTheftDeviceInvoiceAnalysis?.error);
    },
    canOpenAnalysisModal() {
      return Boolean(this.antiTheftDeviceInvoiceAnalyzedAt) || this.analysisHasError;
    },
    analysisBadgeLabel() {
      if (this.analysisHasError) return this.t("unavailable");
      if (!this.antiTheftDeviceInvoiceAnalyzedAt) return this.t("not_analyzed");
      return verdictLabel(this.t, this.analysisVerdict);
    },
  },
};
</script>

<i18n src="./AntiTheftDeviceInvoiceAnalysisBadge.i18n.json"></i18n>
